import { CircleHelp } from "lucide-react";

import { useHelpContext } from "@/lib/help-queries";

import { useHelp, type HelpApi } from "./HelpProvider";

/**
 * A small "?" next to a field or status that needs explaining. It draws nothing unless the key has
 * an article this person can see (so it never opens an empty panel or hints at hidden articles),
 * and nothing at all outside the help provider (no organization there either, so no lookup).
 */
export function HelpHint({ helpKey, label }: { helpKey: string; label: string }) {
  const help = useHelp();
  if (!help) return null;
  return <LookedUpHint help={help} helpKey={helpKey} label={label} />;
}

function LookedUpHint({ help, helpKey, label }: { help: HelpApi; helpKey: string; label: string }) {
  const article = useHelpContext(helpKey);
  if (!article.data) return null;
  return (
    <button
      type="button"
      onClick={() => help.open({ key: helpKey })}
      aria-label={`Help: ${label}`}
      aria-haspopup="dialog"
      className="inline-grid size-6 shrink-0 cursor-pointer place-items-center rounded-md align-middle text-fg-subtle transition-colors hover:text-fg focus-visible:outline-2 focus-visible:outline-brand-500"
    >
      <CircleHelp className="size-4" aria-hidden />
    </button>
  );
}
